import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import DatoImage from '~components/dato-image';
import trimHttps from '~utils/trim-https';
import { Heading, LinkBox, LinkOverlay, Stack, Text } from '@chakra-ui/react';
var ProjectItem = function(props) {
    var ref;
    var data = props.data;
    return(/*#__PURE__*/ _jsxs(LinkBox, {
        _hover: {
            boxShadow: 'lg',
            translateY: '-4px'
        },
        bgColor: "blackAlpha.50",
        borderRadius: "md",
        boxShadow: "sm",
        d: "inline-block",
        overflow: "hidden",
        pos: "relative",
        role: "group",
        transform: "auto-gpu",
        transitionDuration: "fast",
        transitionProperty: "common",
        transitionTimingFunction: "ease-out",
        children: [
            /*#__PURE__*/ _jsx(DatoImage, {
                _groupHover: {
                    filter: 'blur(2px)'
                },
                d: "block",
                data: (ref = data.cover) === null || ref === void 0 ? void 0 : ref.responsiveImage,
                transitionDuration: "normal",
                transitionProperty: "common",
                transitionTimingFunction: "ease-out"
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                _groupHover: {
                    opacity: 1
                },
                align: "center",
                bgColor: "blackAlpha.700",
                inset: 0,
                justify: "center",
                opacity: 0,
                pos: "absolute",
                px: 8,
                py: 4,
                transitionDuration: "normal",
                transitionProperty: "common",
                transitionTimingFunction: "ease-out",
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        size: "md",
                        children: data.title
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        fontSize: [
                            'xs',
                            'sm'
                        ],
                        children: data.subtitle
                    }),
                    data.url !== null && /*#__PURE__*/ _jsx(LinkOverlay, {
                        color: "yellow.200",
                        fontSize: [
                            'xs',
                            'sm'
                        ],
                        href: data.url,
                        isExternal: true,
                        pb: 4,
                        children: trimHttps(data.url)
                    })
                ]
            })
        ]
    }, data.id));
};
export default ProjectItem;
